export const useRecurringAppointment = (
  appointmentId: string | null | undefined,
): boolean => {
  return !!appointmentId?.match(/^(r-)[0-9a-f]{24}-.*/);
};
